import { Box, MenuItem } from "@mui/material";
import { useMemo } from "react";
import { ALLOWED_STATUSES_STOCK } from "src/constants";
import { notifyError } from "src/generic-ui";
import CustomDropDown from "src/generic-ui/CustomDropDown";
import { logger } from "src/services";
import { feedbackService } from "src/services/feedback.service";
import { priceService } from "src/services/price.service";
import { stockService } from "src/services/stock.service";
import { FEEDBACK_STATUS, IPrice, STATUS } from "src/types";

export function FeedbackStatusSelect({
  row,
  onRefresh,
}: {
  row: any;
  onRefresh?: () => void;
}) {
  const updateStatus = async (value: string, feedbackId: string) => {
    try {
      await feedbackService.updateFeedback({ id: feedbackId, status: value });
    } catch (error) {
      logger.error(error);
      notifyError(error?.message);
    } finally {
      onRefresh?.();
    }
  };

  const status = useMemo(() => {
    return row.status;
  }, [row.status]);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "start",
        flexDirection: "column",
        alignItems: "start",
        width: "100%",
      }}
    >
      <CustomDropDown
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        fullWidth
        hasConfirmation={true}
        margin="dense"
        size="small"
        value={status}
        onChange={(value) => updateStatus(value, row.id)}
        sx={{
          width: "7rem",
        }}
      >
        {FEEDBACK_STATUS.map((item: any, key: number) => {
          const isOptionDisabled = status != FEEDBACK_STATUS[0].value;
          return (
            <MenuItem key={key} value={item?.value} disabled={isOptionDisabled}>
              {item?.label}
            </MenuItem>
          );
        })}
      </CustomDropDown>
    </Box>
  );
}
